<template>

    <div class="d-flex align-center justify-center" style="height: 100%;">

        <div class="d-flex flex-column align-center">

            <v-avatar size="64px" class="warning">

                <v-icon class="white--text">mdi-lock</v-icon>

            </v-avatar>

            <h1 class="mt-6 mb-3" style="font-size: 2em;">{{$t('main.access_denied.header')}}</h1>
            <div class="text-center grey--text" v-html="$t('main.access_denied.body')"></div>
            <v-btn to="home" color="indigo" class="white--text mt-6">{{$t('shared.go_home_btn_label')}}</v-btn>
        </div>

    </div>

</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'AccessDenied'
}
</script>